var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfficeBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 22L1 22L1 23L2 23L2 22ZM2 2L2 0.999999C1.44772 0.999999 1 1.44771 1 2L2 2ZM15 2L16 2C16 1.44772 15.5523 1 15 1L15 2ZM15 22L15 23L16 23L16 22L15 22ZM3 22L3 2L1 2L1 22L3 22ZM15 21L2 21L2 23L15 23L15 21ZM15 1L2 0.999999L2 3L15 3L15 1ZM14 2L14 22L16 22L16 2L14 2Z",
    fill: "#12161D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22L14 22L14 23L15 23L15 22ZM15 8L15 7C14.4477 7 14 7.44772 14 8L15 8ZM22 8L23 8C23 7.44772 22.5523 7 22 7L22 8ZM22 22L22 23L23 23L23 22L22 22ZM16 22L16 8L14 8L14 22L16 22ZM22 21L15 21L15 23L22 23L22 21ZM22 7L15 7L15 9L22 9L22 7ZM21 8L21 22L23 22L23 8L21 8Z",
    fill: "#12161D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8L10.5 7",
    stroke: "#12161D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8L6 7",
    stroke: "#12161D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13L10.5 12",
    stroke: "#12161D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13L6 12",
    stroke: "#12161D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18L10.5 17",
    stroke: "#12161D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18L6 17",
    stroke: "#12161D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13L18.5 12",
    stroke: "#12161D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18L18.5 17",
    stroke: "#12161D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeBuilding);
export default __webpack_public_path__ + "static/media/office-building.7301edc3c7c6e6bea96c1c7ffeb52f29.svg";
export { ForwardRef as ReactComponent };